module.exports = __webpack_public_path__ + "img/TW.deedfcbe.svg";